// src/assets/js/pages/home/main.js

import { initHeaderActiveNav, initHeaderCTA } from '../common/header.js';
import { initHeroCarousel } from './heroCarousel.js';
import { initHomeFavorites } from './homeFavorites.js';

document.addEventListener('DOMContentLoaded', () => {
	initHeaderActiveNav();
	initHeaderCTA();

	initHeroCarousel({
		root: document.querySelector('.hero-carousel'),
		intervalMs: 6000,
	});

	initHomeFavorites({
		root: document,
		storageKey: 'selectivia:favs',
	});
});

document.addEventListener('click', (e) => {
	const btn = e.target.closest('[data-action="open-subject"]');
	if (!btn) return;

	const card = btn.closest('[data-subject-id], .subject-card');
	const subjectId = String(btn.dataset.subjectId || card?.dataset.subject || '').trim();
	if (!subjectId) return;

	e.preventDefault();
	e.stopPropagation();

	// redirige a la página de cuestionarios filtrada
	const href = `./quizzes.html?subject=${encodeURIComponent(subjectId)}`;
	window.location.href = href;
});
